export default __webpack_public_path__ + "static/content-6dc91d22d98796a7ba7d1e29fae849b6.jpg";